<div class="obs-dialog-container">
  <div class="obs-header">
    <div style="display: flex; flex-direction: column; gap: 4px">
      <h2 class="obs-title">Revisión de Programación</h2>
      <p class="obs-subtitle">
        Ventas debe marcar com resuelto las revisiones, posterior a ello,
        programación podrá aprobar o no aprobar la resolución dada por DS. El
        estado del File estará como "REVISAR" hasta que todas las revisiiones
        sean aprobadas.
      </p>
    </div>
    <div style="display: flex; gap: 8px; align-items: center">
      <button
        mat-icon-button
        (click)="refreshIncidents()"
        [disabled]="isLoading"
        title="Actualizar"
      >
        <mat-icon>refresh</mat-icon>
      </button>
      <div *ngIf="incidents.length > 0">
        <button
          class="obs-btn-outline"
          (click)="openAddPreOperativeIncident()"
          [disabled]="isAddingObservation"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
          "
        >
          <mat-spinner *ngIf="isAddingObservation" diameter="20"></mat-spinner>
          Agregar observación
        </button>
      </div>
    </div>
  </div>

  <div class="loader-container">
    <div
      *ngIf="isLoading"
      class="loader-container"
      style="display: flex; flex-direction: column; gap: 16px; flex: 1"
    >
      <div
        style="
          display: flex;
          align-items: center;
          gap: 12px;
          color: #475569;
          font-size: 14px;
          font-weight: 500;
          padding: 4px 0 8px;
        "
      >
        <mat-spinner diameter="28"></mat-spinner>
        <span>{{ loadingMessage }}</span>
      </div>
      <div
        style="
          width: 100%;
          height: 110px;
          background: #f9fafb;
          border-radius: 8px;
        "
      ></div>
      <div
        style="
          width: 100%;
          height: 110px;
          background: #f9fafb;
          border-radius: 8px;
        "
      ></div>
      <div
        style="
          width: 100%;
          height: 110px;
          background: #f9fafb;
          border-radius: 8px;
        "
      ></div>
      <div
        style="
          width: 100%;
          height: 110px;
          background: #f9fafb;
          border-radius: 8px;
        "
      ></div>
    </div>

    <ng-container *ngIf="!isLoading">
      <ng-container *ngIf="incidents.length === 0; else listIncidents">
        <div class="obs-empty">
          <i-tabler name="inbox" class="obs-empty-icon"></i-tabler>
          <p class="obs-empty-title">Este file no cuenta con observaciones</p>
          <p class="obs-empty-subtitle">
            Si necesitas agregar una observación, ¡dale click al botón para
            rellenar el formulario!
          </p>
          <button
            class="obs-btn-outline"
            (click)="openAddPreOperativeIncident()"
            [disabled]="isAddingObservation"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              margin: 0 auto;
            "
          >
            <mat-spinner
              *ngIf="isAddingObservation"
              diameter="20"
            ></mat-spinner>
            Agregar observación
          </button>
        </div>
      </ng-container>

      <ng-template #listIncidents>
        <div class="obs-list">
          <div
            class="obs-card"
            *ngFor="let incident of incidents; let i = index"
            [ngClass]="{
              'border-gray':
                incident.incidentStatus === this.INCIDENT_STATUS.PENDING ||
                incident.incidentStatus === this.INCIDENT_STATUS.RESOLVED,
              'border-green':
                incident.incidentStatus === this.INCIDENT_STATUS.APPROVED,
              'border-red':
                incident.incidentStatus === this.INCIDENT_STATUS.NOT_APPROVED
            }"
          >
            <div class="obs-card-header">
              <h3
                class="obs-card-title"
                [ngClass]="{
                  'text-orange':
                    incident.incidentStatus === this.INCIDENT_STATUS.PENDING,
                  'text-green':
                    incident.incidentStatus === this.INCIDENT_STATUS.RESOLVED ||
                    incident.incidentStatus === this.INCIDENT_STATUS.APPROVED,
                  'text-red':
                    incident.incidentStatus ===
                    this.INCIDENT_STATUS.NOT_APPROVED
                }"
              >
                {{ incident.incidentReason }}
              </h3>
              <button
                mat-icon-button
                class="obs-card-menu"
                [matMenuTriggerFor]="menu"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu" class="custom-obs-menu">
                <button
                  mat-menu-item
                  (click)="deleteIncident(incident, i)"
                  class="delete-menu-item"
                >
                  <mat-icon>delete</mat-icon>
                  <span>Eliminar observación</span>
                </button>
              </mat-menu>
            </div>
            <p
              class="obs-card-desc"
              [ngClass]="{
                'border-left-orange':
                  incident.incidentStatus === this.INCIDENT_STATUS.PENDING,
                'border-left-green':
                  incident.incidentStatus === this.INCIDENT_STATUS.RESOLVED ||
                  incident.incidentStatus === this.INCIDENT_STATUS.APPROVED,
                'border-left-red':
                  incident.incidentStatus === this.INCIDENT_STATUS.NOT_APPROVED
              }"
            >
              {{ incident.description }}
            </p>
            <div class="obs-card-footer">
              <div class="obs-pill">
                <i-tabler name="map-pin" class="obs-pill-icon"></i-tabler>
                {{ incident.destination }}
              </div>
              <div class="obs-pill">
                <i-tabler
                  name="calendar-event"
                  class="obs-pill-icon"
                ></i-tabler>
                {{ incident.incidentDate | date: "dd/MM/yy" }}
                <i-tabler
                  name="arrow-narrow-right"
                  class="obs-pill-icon"
                ></i-tabler>
                {{ incident.deadline | date: "dd/MM/yy" }}
              </div>

              <div
                class="obs-pill"
                *ngIf="incident.incidentStatus !== this.INCIDENT_STATUS.PENDING"
                [ngClass]="{
                  'obs-pill-light-green':
                    incident.incidentStatus === this.INCIDENT_STATUS.RESOLVED ||
                    incident.incidentStatus === this.INCIDENT_STATUS.APPROVED,
                  'obs-pill-light-red':
                    incident.incidentStatus ===
                    this.INCIDENT_STATUS.NOT_APPROVED
                }"
              >
                <i-tabler
                  name="progress-check"
                  *ngIf="
                    incident.incidentStatus === this.INCIDENT_STATUS.RESOLVED
                  "
                  class="obs-pill-icon"
                ></i-tabler>
                <i-tabler
                  *ngIf="
                    incident.incidentStatus === this.INCIDENT_STATUS.APPROVED
                  "
                  name="circle-check"
                  class="obs-pill-icon"
                ></i-tabler>
                <i-tabler
                  *ngIf="
                    incident.incidentStatus ===
                    this.INCIDENT_STATUS.NOT_APPROVED
                  "
                  name="circle-x"
                  class="obs-pill-icon"
                ></i-tabler>

                <span
                  *ngIf="
                    incident.incidentStatus === this.INCIDENT_STATUS.RESOLVED
                  "
                  >Resuelto por DS</span
                >
                <span
                  *ngIf="
                    incident.incidentStatus === this.INCIDENT_STATUS.APPROVED
                  "
                  >Aprobado por {{ incident.approvedBy }}</span
                >
                <span
                  *ngIf="
                    incident.incidentStatus ===
                    this.INCIDENT_STATUS.NOT_APPROVED
                  "
                  >No Aprobado</span
                >
              </div>

              <div class="obs-card-actions" *ngIf="isUpdating">
                <mat-spinner diameter="24"></mat-spinner>
              </div>
              <div class="obs-card-actions" *ngIf="!isUpdating">
                <ng-container
                  *ngIf="
                    incident.incidentStatus === this.INCIDENT_STATUS.RESOLVED
                  "
                >
                  <i-tabler
                    name="circle-check"
                    matTooltip="Resuelto, ¿Aprobar resolución?"
                    matTooltipPosition="above"
                    class="obs-action-icon"
                    (click)="
                      updateIncidentStatus(
                        incident,
                        this.INCIDENT_STATUS.APPROVED
                      )
                    "
                  ></i-tabler>
                  <i-tabler
                    name="circle-x"
                    matTooltip="Resuelto, ¿No aprobar resolución?"
                    matTooltipPosition="above"
                    class="obs-action-icon"
                    (click)="
                      updateIncidentStatus(
                        incident,
                        this.INCIDENT_STATUS.NOT_APPROVED
                      )
                    "
                  ></i-tabler>
                </ng-container>

                <ng-container
                  *ngIf="
                    incident.incidentStatus === this.INCIDENT_STATUS.APPROVED
                  "
                >
                  <i-tabler
                    name="circle-check-filled"
                    style="
                      width: 24px;
                      height: 24px;
                      stroke-width: 3;
                      color: green !important;
                    "
                  ></i-tabler>
                </ng-container>

                <ng-container
                  *ngIf="
                    incident.incidentStatus ===
                    this.INCIDENT_STATUS.NOT_APPROVED
                  "
                >
                  <div class="action-icon-solid-red">
                    <i-tabler
                      name="circle-x-filled"
                      style="
                        width: 24px;
                        height: 24px;
                        stroke-width: 3;
                        color: red !important;
                      "
                    ></i-tabler>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <div class="obs-footer">
    <ng-container *ngIf="incidents.length > 0 && hasMigratedIncidents">
      <p class="obs-footer-text">
        Si el destino o la fecha límite no están disponibles o quién aprobó la
        revisión fue "Sistema", es debido a una migración del sistema a este
        nuevo formato de incidentes, previamente no se registraba esta
        información.
      </p>
    </ng-container>
    <button class="obs-btn-outline obs-btn-close" (click)="close()">
      Cerrar
    </button>
  </div>
</div>
